const TranscriptFragmentRole = {
  AGENT: "agent",
  PARTICIPANT: "participant"
};
function mapInterviewTranscriptFragmentsToPublicAPIFormat(transcriptFragments) {
  const apiFragments = [];
  transcriptFragments.forEach((fragment) => {
    if (fragment.question) {
      apiFragments.push({
        role: TranscriptFragmentRole.AGENT,
        transcript: fragment.question,
        started_at: fragment.start_time,
        ended_at: fragment.end_time
      });
      apiFragments.push({
        role: TranscriptFragmentRole.PARTICIPANT,
        transcript: fragment.text_transcript || "",
        started_at: fragment.start_time,
        ended_at: fragment.end_time
      });
    } else if (fragment.role) {
      apiFragments.push({
        role: fragment.role,
        transcript: fragment.text_transcript || "",
        started_at: fragment.start_time,
        ended_at: fragment.end_time
      });
    }
  });
  return apiFragments;
}
export {
  TranscriptFragmentRole,
  mapInterviewTranscriptFragmentsToPublicAPIFormat
};
//# sourceMappingURL=transcriptFragment.js.map
